import { render } from "./ConfirmActionDialog.vue?vue&type=template&id=4050c0ee"
import script from "./ConfirmActionDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmActionDialog.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__